// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3eXhe","disabled":"FileBtn_disabled__30xFv","warn":"FileBtn_warn__8fegd","fade":"FileBtn_fade__25nMC"};